import type { ShoppingCartState } from './types';

export const initialState: ShoppingCartState = {
  data: null,
  isLoading: false,
  error: null,
  config: null,
};
